import React from 'react';
import { Table } from 'reactstrap';

const TableHosting = (props) => {
  return (
    <Table bordered style={{ maxWidth: 600, alignSelf: 'center' }}>
      <thead>
        <tr>
          <th>Details</th>
          <th>Pay as You Go</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><p>{`Authentication -`}</p>
            <p>{`(Phone - US, Canada, and India)`}</p>
            <p>{`(Phone - All other countries)`}</p>
            <p>{`Other`}</p>
          </td>
          <td>
            <p>$0.02/verification</p>
            <p>$0.12/verification</p>
          </td>
        </tr>
        <tr>
          <td><p>Cloud Firestore</p>
            <p>- Stored data</p>
            <p>​- Network egress​​</p></td>
          <td><p>$0.36/GiB</p>
            <p>Google Cloud pricing</p></td>
        </tr>
        <tr>
          <td><p>Cloud Firestore​</p>
            <p>- Document writes</p>
            <p>- Document reads</p>
            <p>- Document deletes</p></td>
          <td><p>$0.36/100K </p>
            <p>$0.12/100K</p>
            <p>$0.04/100K</p></td>
        </tr>

        <tr>
          <td><p>Cloud Functions</p>
            <p>- Invocations</p>
            <p>- GB-seconds</p></td>
          <td><p>​$0.80/million </p>
            <p>$0.005/thousand​</p></td>
        </tr>

        <tr>
          <td>{`Crashlytics`}</td>
          <td>{`Included`}</td>
        </tr>

        <tr>
          <td>{`​Performance Monitoring`}</td>
          <td>{`Included`}</td>
        </tr>

        <tr>
          <td><p>Storage</p>
            <p>- GB stored</p>
            <p>- ​GB downloaded</p></td>
          <td><p>$0.052/GB</p>
            <p>$0.24/GB</p></td>
        </tr>

        <tr>
          <td><p>Storage​</p>
            <p>- Upload operations</p>
            <p>- Download operations</p></td>
          <td><p>$0.1/10k</p>
            <p>$0.008/10k</p></td>
        </tr>
      </tbody>
    </Table>
  );
}

export default TableHosting;